export const HELP_LINKS = {
	documentation: 'https://docs.descope.com',
	community: 'https://www.descope.com/community'
};

export const SUPPORT_MAIL = 'support@descope.com';
